import { useEffect, useMemo, useState } from "react";
import {
  Container,
  ContainerRow,
  ContainerView,
} from "../../../components/Container";
import { Form } from "antd";
import { useApp } from "../../../contexts";
import {
  WalletConvertInfo,
  WalletConvertInfoItem,
  WalletConvertInfoItemTitle,
  WalletConvertInfoItemValue,
} from "../../wallet-detail/styles";
import {
  FormButton,
  FormInputNumberRaw,
  FormItemRow,
  FormSelect,
} from "../../../components/Form";
import {
  errorView,
  formatCurrency,
  getWalletList,
  getWithdrawFee,
  ssoGetUserInfo,
  postWithdraw,
} from "../../../services/app";
import WithDrawSOTStep2 from "./WithDrawSOTStep2";
import produce from "immer";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { TitleWithBack } from "../../../components/Layout";
import {
  StepBody,
  StepHead,
  Steps,
  Step,
  WithdrawFormContainer,
} from "../styles";
import FormInput from "../../../components/FormCustom2/Input";
import { TYPE_WALLET_DETAIL } from "../../../constants";
import { error, success } from "../../../Notification";
import { isSOTd, isAddress } from "../../../utils/helper";
import { ModalPasswordRequired } from "../../../components/ModalPasswordRequired";

export default function WithDrawSOT(props) {
  const {
    T,
    getCurrency,
    convertToBTC,
    convertToLocalCurrency,
    currencies,
    loadContextData,
    setAlert,
    cryptoCodes,
    setLoading,
  } = useApp();

  const navigate = useNavigate();
  let { code, walletId, type } = props || {};
  const params = useParams();
  const [searchParams] = useSearchParams();
  if (!code && searchParams.get("code")) {
    code = searchParams.get("code");
  }
  if (!walletId && searchParams.get("walletId")) {
    walletId = searchParams.get("walletId");
  }
  if (!type && searchParams.get("type")) {
    type = searchParams.get("type");
  }
  const [fee, setFee] = useState(0);
  const [form] = Form.useForm();
  const [step2Data, setStep2Data] = useState({});
  const [step, setStep] = useState(1);
  const [available, setAvailable] = useState(false);
  const [showPaste, $showPaste] = useState(true);
  const [showSetPassword, setShowSetPassword] = useState(false);
  const [wallets, setWallets] = useState([]);
  const [wallet, setWallet] = useState(code);
  const [errors, setErrors] = useState([]);
  const isOption = type === TYPE_WALLET_DETAIL.OPTION;
  // is option

  useEffect(() => {
    if (code) {
      form.setFieldsValue({
        coin: currencies.find((x) => x.code === code) ? code : "",
      });
      setWallet(code);
    }
    loadData();
  }, [code]);

  const onBack = () => {
    navigate(-1);
  };

  const loadData = async () => {
    setLoading(true);
    let result = await getWalletList();
    if (result.status === 200) {
      const items = result?.data?.data?.wallets?.rows || [];
      setWallets(items);
    }
    setLoading(false);
  };

  const loadFee = async (amount, currencyCode) => {
    let result = await getWithdrawFee(amount, currencyCode);
    if (result?.status === 200) {
      setFee(result?.data?.data ? Number(result?.data?.data) : 0);
    }
  };
  const checkUserHasPassword = async () => {
    try {
      let result = await ssoGetUserInfo();
      if (result?.data?.data?.has_password) {
        return true;
      }
      return false;
    } catch (err) {
      return false;
    }
  };
  const onConvert = async (values) => {
    const validatePassword = await checkUserHasPassword();
    if (!validatePassword) {
      setShowSetPassword(true);
      return;
    }
    setLoading(true);
    const result = await postWithdraw({
      fromWalletId: row?.id,
      destWalletAddress: values.to,
      amount: values.amount,
    });
    setLoading(false);
    if (result.status === 200) {
      setStep2Data({
        ...(result?.data?.data || {}),
        ...(result?.data?.data?.dataValues || {}),
      })
      loadContextData();
      setStep(2)
    } else {
      setErrors(result?.data?.error?.validates || []);
      if (!(result?.data?.error?.validates || []).length) {
        error(
          result?.data?.error?.message ||
            T("Failed to create a withdrawal request")
        );
      }
    }
  };

  const convertData = () => {
    let itemWallet = wallets.find((item) => item.currency_code === wallet);
    const data = {
      wallets: wallets.map((item, index) => {
        return {
          ...item,
          coin: item.currency_code,
          amount: item.dog_food,
          btc: convertToBTC(item.dog_food, item.currency_code, getCurrency()),
          local: convertToLocalCurrency(
            item.dog_food,
            item.currency_code,
            getCurrency()
          ),
        };
      }),
      wallet: itemWallet
        ? {
            ...itemWallet,
            coin: itemWallet.currency_code,
            amount: itemWallet.dog_food,
            btc: convertToBTC(
              itemWallet.dog_food,
              itemWallet.currency_code,
              getCurrency()
            ),
            local: convertToLocalCurrency(
              itemWallet.dog_food,
              itemWallet.currency_code,
              getCurrency()
            ),
          }
        : {},
    };
    if (isOption && form) {
      form.setFieldValue("amount", data?.wallet?.amount || 0);
    }
    return data;
  };

  const onUpdateData = () => {
    const values = form.getFieldsValue();
    if (values.coin && values.amount) {
      loadFee(values.amount, values.coin);
    }
    if (values.to) {
      $showPaste(false);
    }else{
      $showPaste(true)
    }
    setAvailable(values.coin && values.amount && values.to && isAddress(values.to));
  };

  const onTransactionHistory = () => {
    let codeOrigin = code;
    let idOrigin = walletId;
    if (row.currency_code) {
      codeOrigin = row.currency_code;
    }
    if (row.id) {
      idOrigin = row.id;
    }
    navigate(
      `/wallet-detail/${type}?code=${codeOrigin || ""}&walletId=${idOrigin}`
    );
  };
  const onSetPassword = () => {
    navigate(`/change-password`);
  };
  const rows = convertData().wallets || [];
  const row = convertData().wallet || {};
  const renderOption = () => {
    if (isOption || isSOTd(code)) {
      const SOTdsObj = {};
      const listSOTds = [...(wallets ?? [])].filter((item) =>
        isSOTd(item.currency_code)
      );
      listSOTds.forEach((item) => {
        SOTdsObj[item.currency_code] = item.can_auto_withdraw;
      });
      const listCurrentCies = currencies?.filter(
        (item) => !!SOTdsObj[item.code]
      );

      return listCurrentCies.map((item, index) => {
        return (
          <FormSelect.Option key={index.toString()} value={item.code}>
            {T(`${item.name} (${item.code})`)}
          </FormSelect.Option>
        );
      });
    }
  };
  const handleOnPaste = () => {
    navigator.clipboard.readText().then((cliptext) => {
      form.setFieldsValue({
        to: cliptext,
      });
      form.validateFields(["to"]);
      onUpdateData();
    }).catch((error) => {
      console.error("Failed to read clipboard contents: ", error);
    });
    $showPaste(false)
  };
  const handleOnRemove = () => {
    form.setFieldsValue({
      to: '',
    });
    form.validateFields(["to"]);
    onUpdateData();
    $showPaste(true)
  };

  return rows?.length ? (
    <Container>
      <ContainerView>
        <TitleWithBack title={T("Withdrawal Request")} onClick={onBack} />
        <Steps>
          <Step className="step-sot">
            <div>
              <StepHead>
                <img src="/assets/images/otc/step1.svg" />
                <span>{T("Select Coin")}</span>
              </StepHead>
              <StepBody>
                {T("Select the currency that you want to withdraw")}
              </StepBody>
            </div>
            <div className={"arrow"} />
          </Step>
          <Step className="step-sot">
            <div>
              <StepHead>
                <img src="/assets/images/otc/step2.svg" />
                <span>{T("Enter Information")}</span>
              </StepHead>
              <StepBody>
                {T(
                  "Copy and paste the deposit address and enter the amount you want to send"
                )}
              </StepBody>
            </div>
            <div className={"arrow"} />
          </Step>
          <Step className="step-sot">
            <div>
              <StepHead>
                <img src="/assets/images/otc/step3.svg" />
                <span>{T("Wait for Approval")}</span>
              </StepHead>
              <StepBody>
                {T("Please wait while we review your request")}
              </StepBody>
            </div>
            <div className={"arrow"} />
          </Step>
          <Step className="step-sot">
            <div>
              <StepHead>
                <img src="/assets/images/otc/step4.svg" />
                <span>{T("Receive Result")}</span>
              </StepHead>
              <StepBody>
                {T("Deposit successfully sent to recipient’s address")}
              </StepBody>
            </div>
          </Step>
        </Steps>

        <WithdrawFormContainer>
          {step == 1 ? 
            <Form
              form={form}
              onFinish={(values) => {
                onConvert(form.getFieldsValue());
              }}
              onValuesChange={() => {
                onUpdateData();
              }}
            >
            <FormItemRow
              {...errorView(errors, "fromWalletId")}
              name={"coin"}
              className="no-after option-token-row"
              label={T("Select Token")}
              initialValue={currencies.find((x) => x.code === code) ? code : ""}
              rules={[{ required: true, message: T("Coin is required!") }]}
            >
              <FormSelect
                onChange={(value) => {
                  if (!!value) {
                    setWallet(value);
                  }
                  form.setFieldValue("to", "");
                  form.setFieldValue("amount", "");
                  setErrors(
                    produce((draft) => {
                      draft.splice(
                        draft.findIndex((item) => item.key === "fromWalletId"),
                        1
                      );
                    })
                  );
                }}
              >
                {renderOption()}
              </FormSelect>
            </FormItemRow>
            <div className="relative">
              <FormItemRow
                {...errorView(errors, "destWalletAddress")}
                className="no-after option-token-row"
                name={"to"}
                label={T("Recipient’s address")}
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value) {
                        return Promise.reject(
                          new Error(T("Recipient’s address is required"))
                        );
                      }
                      if (!isAddress(value)) {
                        return Promise.reject(new Error(T("Invalid Address")));
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <FormInput
                  className="pr-[40px]"
                  onChange={() => {
                    setErrors(
                      produce((draft) => {
                        draft.splice(
                          draft.findIndex(
                            (item) => item.key === "destWalletAddress"
                          ),
                          1
                        );
                      })
                    );
                  }}
                  placeholder={T("Please enter your address")}
                />
              </FormItemRow>
              {!showPaste ? (
                <>
                  <div onClick={()=>handleOnRemove()} className="cursor-pointer absolute text-[14px] right-[16px] top-[58px] sm:top-[50px]">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_5498_25909)">
                        <circle
                          cx="7.99967"
                          cy="8.00065"
                          r="6.66667"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M9.66633 6.334L6.33301 9.66732M6.33299 6.33398L9.66631 9.6673"
                          stroke="black"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_5498_25909">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </>
              ) : (
                <div
                  className="text-aia-red cursor-pointer absolute text-[14px] right-[16px] top-[56px] sm:top-[46px]"
                  onClick={() => handleOnPaste()}
                >
                  {T("Paste")}
                </div>
              )}
            </div>
            <FormItemRow
              initialValue={isOption ? row?.amount : undefined}
              {...errorView(errors, "amount")}
              name={"amount"}
              label={T("Sent amount (Only full withdrawal supported)")}
              className="no-after option-token-row"
              rules={[{ required: true, message: T("Amount is required!") }]}
            >
              <FormInputNumberRaw
                className="option-token-input"
                readOnly={isOption}
                onChange={() => {
                  setErrors(
                    produce((draft) => {
                      draft.splice(
                        draft.findIndex((item) => item.key === "amount"),
                        1
                      );
                    })
                  );
                }}
                min={0}
                onAll={() => {
                  form.setFieldValue("amount", parseFloat(row?.amount));
                  setErrors(
                    produce((draft) => {
                      draft.splice(
                        draft.findIndex((item) => item.key === "amount"),
                        1
                      );
                    })
                  );
                  onUpdateData();
                }}
                addonAfter={row?.coin || ""}
                placeholder={T(`Please enter the {coin} amount`).replace(
                  "{coin}",
                  row?.coin || ""
                )}
              />
            </FormItemRow>

            <ContainerRow style={{ marginTop: 41, marginBottom: 41 }}>
              <WalletConvertInfo style={{ flex: 1 }}>
                <WalletConvertInfoItem>
                  <WalletConvertInfoItemTitle>
                    {T("Balance")}
                  </WalletConvertInfoItemTitle>
                  <WalletConvertInfoItemValue
                    style={{ marginLeft: 0 }}
                    className={"text-aia-red"}
                  >
                    {formatCurrency(row?.amount || 0, null, getCurrency())} {row?.coin}
                  </WalletConvertInfoItemValue>
                </WalletConvertInfoItem>
                <WalletConvertInfoItem>
                  <WalletConvertInfoItemTitle>
                    {T("Fee")}
                  </WalletConvertInfoItemTitle>
                  <WalletConvertInfoItemValue
                    className={"text-aia-red"}
                    style={{ marginLeft: 0 }}
                  >
                    {fee ? formatCurrency(fee || 0, null, getCurrency()) + " " + row?.coin : T("Free")}
                  </WalletConvertInfoItemValue>
                </WalletConvertInfoItem>
              </WalletConvertInfo>
            </ContainerRow>

            <Container className="!pl-0">
              <FormButton
                disabled={!available}
                htmlType={"button"}
                onClick={() => {
                  form.submit();
                }}
              >
                {T("Withdraw")}
              </FormButton>
            </Container>
          </Form>: 
          <WithDrawSOTStep2 
          value={step2Data}
          onBack={
            (value) => {
              setStep2Data({});
              setStep(1)
              if (value) {
                value === "success"
                  ? success(T("Your withdrawal request has been created and under processing. Please check your transaction history."))
                  : error(T("Failed to create a withdrawal request"));
                if (value === "success") {
                  setAvailable(false);
                  form.resetFields();
                  onTransactionHistory();
                }
              }
              loadData();
            }
          } />
        } 
        </WithdrawFormContainer>
      </ContainerView>
      {showSetPassword && (
        <ModalPasswordRequired
          onClose={() => setShowSetPassword(false)}
          onSubmit={() => onSetPassword()}
        />
      )}
    </Container>
  ) : null;
}
